/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vehicle_Type_TruckInputs */

const vi_vehicle_type_truck = /** @type {(inputs: Vehicle_Type_TruckInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xe tải`)
};

/**

* @param {Vehicle_Type_TruckInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const vehicle_type_truck = /** @type {((inputs?: Vehicle_Type_TruckInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vehicle_Type_TruckInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_vehicle_type_truck(inputs)
});